import TC from "components/Stacker/constants/ToggleConstants"

const initialState = {}

export default function toggle(previousState = initialState, action) {
  const getToggleState = (id, toggleState) => {
    return typeof toggleState === "boolean" ? toggleState : !previousState[id]
  }
  switch (action.type) {
    case TC.TOGGLE_TOGGLE:
      return {
        ...previousState,
        [action.payload.id]: getToggleState(
          action.payload.id,
          action.payload.toggleState
        ),
      }
    default:
      return previousState
  }
}
